<template>
  <section class="content-wrapper">
    <h1 class="title">{{ title }}</h1>
    <div class="break-line"></div>
    <template v-if="content">
      <div v-html="content" class="content"></div>
    </template>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Docs',

    data() {
      return {
        content: '',
        type: '',
        pathMap: {
          termsofuse: 'program-Term-Of-Use',
          terms: 'program-Terms-and-Conditions',
          privacypolicy: 'Privacy-Policy',
          about: 'program-About',
          programterms: 'Program-TC',
          termsofservice: 'program-Terms-of-Service',
        },
      };
    },

    mounted() {
      this.getInfoFn();
    },

    methods: {
      getInfoFn() {
        const type = this.pathMap[this.$route.params.doc];
        this.type = type;
        this.getContent(this.sliceTitle(type));
      },
      sliceTitle(type) {
        const myType = type;
        if (myType.includes('program-')) {
          return myType.slice(8, myType.length);
        }
        return myType;
      },
      getContent(type) {
        this.content = '';
        console.log('type', type);
        const data = { type, lang: this.$i18n.locale, userId: this.userInfo?.userId };
        this.$http.common.getServiceContent(data).then(res => {
          this.content = res.content;
        });
      },
    },

    watch: {
      $route(newPath, oldPath) {
        if (newPath.path !== oldPath.path) {
          this.getInfoFn();
        }
      },
    },

    computed: {
      title() {
        return this.$i18n.t(this.type);
      },

      ...mapState(['userInfo']),
    },
  };
</script>

<style lang="scss" scoped>
  @use 'index';
</style>
